// component
import { title } from 'process';
import SvgColor from '../../../components/svg-color';
import { Tooltip } from '@mui/material';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  {
    title: 'Dashboard',
    path: '/dashboard/analytics',
    icon: icon('ic_dashboard'),
  },
  {
    title: 'Projects',
    path: '/dashboard/project',
    icon: (
      <Tooltip title="Projects" placement="right-start">
        {icon('ic_file')}
      </Tooltip>
    ),
  },
  {
    title: 'Data Loader',
    path: '/dashboard/dataloader',
    icon: (
      <Tooltip title="Data Loader" placement="right-start">
        {icon('ic_dataloader')}
      </Tooltip>
    ),
  },
  {
    title: 'Users',
    path: '/dashboard/user',
    icon: (
      <Tooltip title="Users" placement="right-start">
        {icon('ic_User')}
      </Tooltip>
    ),
  },
  // {
  //   title: 'Chat',
  //   path: '/dashboard/chat',
  //   icon: icon('ic_message'),
  // },
  // {
  //   title: 'Code Toolkit',
  //   path: '/dashboard/codetoolkit',
  //   icon: icon('ic_terminal'),
  // },
  {
    title: 'settings',
    path: '/dashboard/settings',
    icon: icon('ic_settings'),
  },
];

export default navConfig;
